import { capitalizeFirstLetter } from '../helpers/capitalizeFirstLetter';
import { getLabels } from '../labels';
// formatDayShort(1) -> "Mon"
export const formatDayShort = (day) => capitalizeFirstLetter(getLabels().day_of_week_short[day]);
